export const FETCH_ASSISTANCE_OPTIONS = 'fetchAssistanceOptions'
export const FETCH_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS =
  'fetchDashboardAssistanceTypeFilterOptions'
export const FETCH_OTHER_ASSISTANCE_CATEGORIES_GRID =
  'fetchOtherAssistanceCategoriesGrid'
export const UPDATE_ASSISTANCE_OPTIONS = 'updateAssistanceOptions'
export const FETCH_STATIONS = 'fetchStations'
export const FETCH_STATION = 'fetchStation'
export const CLEAR = 'clear'
export const CLEAR_BY_DIRECTION = 'clearByDirection'
export const CLEAR_PLANNER_BY_DIRECTION = 'clearPlannerByDirection'
export const CLEAR_REPLAN_BY_DIRECTION = 'clearReplanByDirection'
export const SEARCH = 'search'
export const SEARCH_BY_DIRECTION = 'searchByDirection'
export const CONFIRM_LEG_ASSISTANCE = 'confirmLegAssistance'
export const FETCH_BOOKINGS = 'fetchBookings'
export const SELECT_OUTWARD_JOURNEY = 'selectOutwardJourney'
export const SELECT_INWARD_JOURNEY = 'selectInwardJourney'
export const SELECT_ASSISTANCE = 'selectAssistance'
export const APPLY_ASSISTANCE_TO = 'applyAssistanceTo'
export const SELECT_SEATS = 'selectSeats'
export const UPDATE_DEP_MEETING_POINT = 'updateDepMeetingPoint'
export const UPDATE_ARR_MEETING_POINT = 'updateArrMeetingPoint'
export const APPLY_ASSISTANCE_TO_ALL_LEGS = 'applyAssistanceToAllLegs'
export const COPY_ASSISTANCE_FROM = 'copyAssistanceFrom'
export const CREATE_BOOKING = 'createBooking'
export const INIT = 'init'
export const NEW = 'new'
export const UPDATE = 'update'
export const DESTROY = 'destroy'
export const GET = 'getBooking'
export const SEARCH_QUERY_PREFILL = 'searchQueryPrefill'
export const UPDATE_JOURNEY_RETURN_DATE = 'updateJourneyReturnDate'
export const UPDATE_JOURNEY_PLANNER = 'updateJourneyPlanner'
export const SEARCH_ADD_LEG = 'searchAddLeg'
export const SELECT_EXTRA_JOURNEY = 'selectExtraJourney'
export const CLEAR_EXTRA_JOURNEY_FILTER = 'clearExtraJourneyFilter'
export const ONE_TIME_ERROR_NOTIFICATION = 'oneTimeErrorNotification'
